<template>
    <v-dialog v-bind="$attrs" persistent content-class="modal-dialog">
        <div class="modal-message">
            <div class="common-text mb-2">
                Смена имени
            </div>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                class="auth-form"
                @submit.prevent
            >
                <div class="main-text mb-5 text-center">
                    <div class="auth-form__input mb-4">
                        <label for="firstName" class="main-text"> Ваше имя </label>
                        <v-text-field
                            v-model="firstName"
                            id="firstName"
                            :rules="[rules.required]"
                            placeholder="Введите имя"
                            class="dark-input ma-0"
                            dense
                        />
                    </div>
                    <div class="auth-form__input mb-60">
                        <label for="lastName" class="main-text"> Ваша фамилия </label>
                        <v-text-field
                            v-model="lastName"
                            id="lastName"
                            :rules="[rules.required]"
                            placeholder="Введите фамилию"
                            class="dark-input ma-0"
                            dense
                        />
                    </div>
                </div>
                <v-flex class="d-flex w-100 justify-center mt-3">
                    <v-btn class="btn-dark main-text" @click="close">
                        Отменить
                    </v-btn>
                    <v-btn
                        :disabled="!valid"
                        type="submit"
                        class="yellow-btn small-btn main-text"
                        @click="validate"
                    >
                        Сохранить
                    </v-btn>
                </v-flex>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalChangeName",
    props: {
        user: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            firstName: null,
            lastName: null,
            valid: true,
            rules: {
                required: value => !!value || 'Обязательное поле',
            },
        };
    },
    created() {
        this.firstName = this.user.first_name;
        this.lastName = this.user.last_name;
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                this.changeName();
            }
        },
        changeName() {
            this.$http.patch('/users/' + this.user.uid + '/', {
                first_name: this.firstName,
                last_name: this.lastName,
            })
                .then(() => {
                    this.$emit('update');
                    this.close();
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.btn-dark.v-btn {
    max-width: 107px;
}

.yellow-btn.small-btn.v-btn {
    width: auto;
    min-width: 105px;
    max-height: 42px;
    min-height: 42px;
    margin-left: 8px;
}
</style>